/* Irene Quirós · Campaña Halloween (assets/iq-hw.js)
   - «Copiar»: portapapeles del navegador, con alternativa para navegadores antiguos y confirmación «Copiado».
   - Botón principal del hero (data-hw-anchor): desplaza hasta la sección enlazada (#favoritos) respetando el movimiento reducido.
   - Códigos guardados pero no aplicados ahora (por ejemplo, HALLOWEEN10 cuando el descuento por cantidad es igual o más ventajoso):
     se muestran en el campo de cupones del carrito para que el formulario del tema los conserve al añadir o quitar otros códigos.
     Los datos salen de /cart.js; los importes son los que calcula Shopify. */
(function () {
  'use strict';
  var IQ = window.IQ || {};
  var code = IQ.hwCode || 'HALLOWEEN10';

  function announce(scope, text) {
    var live = (scope && scope.querySelector('[data-hw-status]')) || document.querySelector('[data-hw-status]');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 40);
  }

  function legacyCopy(value) {
    var area = document.createElement('textarea');
    area.value = value;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    try { document.execCommand('copy'); } catch (error) { /* sin portapapeles */ }
    area.remove();
  }

  function copyCode(button) {
    var value = button.getAttribute('data-hw-copy') || code;
    var label = button.querySelector('[data-hw-label]') || button;
    var original = button.getAttribute('data-hw-original') || label.textContent;
    button.setAttribute('data-hw-original', original);
    var done = function () {
      label.textContent = 'Copiado';
      button.classList.add('is-done');
      announce(button.closest('[data-hw-scope]'), 'Código ' + value + ' copiado');
      window.setTimeout(function () {
        label.textContent = original;
        button.classList.remove('is-done');
      }, 2200);
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(value).then(done, function () { legacyCopy(value); done(); });
    } else {
      legacyCopy(value);
      done();
    }
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function goToAnchor(link) {
    var id = (link.getAttribute('href') || '').replace(/^#/, '');
    var target = id && document.getElementById(id);
    if (!target) return false;
    target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    var heading = target.querySelector('h2, h3');
    if (heading) {
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
    try { window.history.replaceState(null, '', '#' + id); } catch (error) { /* sin historial */ }
    return true;
  }

  document.addEventListener('click', function (event) {
    var copy = event.target.closest('[data-hw-copy]');
    if (copy) {
      event.preventDefault();
      copyCode(copy);
      return;
    }
    var anchor = event.target.closest('a[data-hw-anchor]');
    if (anchor && goToAnchor(anchor)) event.preventDefault();
  });

  /* Códigos guardados en el carrito que Shopify no aplica ahora */
  var syncTimer = null;
  var busy = false;

  function pendingPill(template, value) {
    var li = document.createElement('li');
    li.className = 'cart-discount__pill iq-pill-pending';
    li.setAttribute('data-discount-code', value);
    li.setAttribute('data-hw-pending', '');
    li.setAttribute('aria-label', 'Código ' + value + ' guardado; no se aplica ahora');
    var p = document.createElement('p');
    p.className = 'cart-discount__pill-code';
    p.textContent = value;
    var note = document.createElement('span');
    note.className = 'iq-pill-pending__note';
    note.textContent = 'no aplicado ahora';
    li.appendChild(p);
    li.appendChild(note);
    var remove = template ? template.cloneNode(true) : document.createElement('button');
    if (!template) {
      remove.type = 'button';
      remove.className = 'cart-discount__pill-remove svg-wrapper svg-wrapper--smaller button-unstyled';
      remove.setAttribute('on:click', '/removeDiscount');
      remove.textContent = '×';
    }
    remove.setAttribute('aria-label', 'Eliminar el descuento ' + value);
    li.appendChild(remove);
    return li;
  }

  function applyCart(cart) {
    var pending = (cart.discount_codes || []).filter(function (item) { return item && item.applicable === false; });
    var codes = pending.map(function (item) { return String(item.code); });
    busy = true;
    document.querySelectorAll('cart-discount-component').forEach(function (component) {
      var list = component.querySelector('.cart-discount__codes');
      if (!list) return;
      list.querySelectorAll('[data-hw-pending]').forEach(function (el) { el.remove(); });
      var shown = Array.prototype.map.call(list.querySelectorAll('.cart-discount__pill'), function (pill) {
        return String(pill.getAttribute('data-discount-code') || '').toUpperCase();
      });
      var template = component.querySelector('.cart-discount__pill-remove');
      codes.forEach(function (value) {
        if (shown.indexOf(value.toUpperCase()) > -1) return;
        list.appendChild(pendingPill(template, value));
      });
    });
    var hwPending = codes.some(function (value) { return value.toUpperCase() === String(code).toUpperCase(); });
    document.querySelectorAll('[data-hw-cart-promo]').forEach(function (promo) {
      var pendingText = promo.querySelector('[data-hw-pending-text]');
      if (!pendingText) return;
      pendingText.hidden = !hwPending;
      promo.querySelectorAll('[data-hw-tiers-text]').forEach(function (el) { el.hidden = hwPending; });
    });
    window.setTimeout(function () { busy = false; }, 0);
  }

  function syncCart() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      if (!document.querySelector('cart-discount-component, [data-hw-cart-promo]')) return;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(applyCart)
        .catch(function () { /* sin datos del carrito */ });
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCart);
  else syncCart();

  try {
    new PerformanceObserver(function (list) {
      var hit = list.getEntries().some(function (entry) {
        return entry.name.indexOf('/cart/') > -1 && /(add|change|update|clear)/.test(entry.name);
      });
      if (hit) syncCart();
    }).observe({ type: 'resource', buffered: false });
  } catch (error) { /* sin PerformanceObserver */ }

  try {
    new MutationObserver(function (mutations) {
      if (busy) return;
      var relevant = mutations.some(function (m) {
        var el = m.target && m.target.nodeType === 1 ? m.target : m.target && m.target.parentElement;
        return !!(el && el.closest && el.closest('cart-discount-component, [data-hw-cart-promo], .iq-cart-extras'));
      });
      if (relevant) syncCart();
    }).observe(document.body, { childList: true, subtree: true });
  } catch (error) { /* sin MutationObserver */ }
})();
